import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Index from '../views/index'
const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/home',
    name: 'index',
    component: Index
  },
  {
    path: '/eve',
    name: 'events',
    component: () => import('../views/events')
  },
  // {
  //   path: '/banner',
  //   name: 'banner',
  //   component: () => import('../views/banner')
  // },
  // {
  //   path: '/country',
  //   name: 'country',
  //   component: () => import('../views/country')
  // },
  // {
  //   path: '/qinhuangdao',
  //   name: 'qinhuangdao',
  //   component: () => import('../views/qinhuangdao')
  // },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  routes
})

export default router
